import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {PwaModeService} from './pwa-mode.service';
import {UserService} from './user.service';
import {isPwaDashboardRouteAllowed} from './pwa-route-policy';

const PWA_HOME = '/dashboard';

@Injectable()
export class PwaRouteGuard implements CanActivate, CanActivateChild {
  constructor(private mode: PwaModeService, private users: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivateChild(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.mode.isEnabled || isPwaDashboardRouteAllowed(state.url, this.users.getLocal())) { return true; }
    this.router.navigateByUrl(PWA_HOME);
    return false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/pwa-route.guard.ts